import { ResponsivePie } from "@nivo/pie";
import { Box, Text } from "@chakra-ui/react";
import { Card } from "../../../../../components/Card";

function DonutChart({ data }) {
  return (
    <ResponsivePie
      data={data}
      margin={{ top: 10, right: 10, bottom: 60, left: 10 }}
      theme={{ legends: { text: { fontSize: 16 } } }}
      innerRadius={0.5}
      padAngle={0.7}
      cornerRadius={3}
      activeOuterRadiusOffset={8}
      tooltip={tooltipObj => {
        const { datum: { data } } = tooltipObj;
        const formattedValue = data.value && data.value > 0 ?
          data.value.toLocaleString("en-GB", { maximumFractionDigits: 4 }) : "";

        return (
          <Box position="relative">
            <Card
              position="absolute"
              minWidth={"300px"}
              padding={3}
              right={"100%"}
            >
              <Text fontSize="sm">
                {data.label}: <b>{formattedValue}</b> tCO<sub>2e</sub>
              </Text>
            </Card>
          </Box>);
      }}
      borderWidth={1}
      borderColor={{
        from: 'color'
      }}
      enableArcLinkLabels={false}
      arcLabel={(el) => {
        return el.data.value && el.data.value > 0 ?
          el.data.value.toLocaleString("en-GB", { maximumFractionDigits: 4 }) : "";
      }}
      arcLabelsSkipAngle={10}
      legends={[
        {
          anchor: 'bottom',
          direction: 'row',
          justify: false,
          translateX: 0,
          translateY: 56,
          itemsSpacing: 0,
          itemWidth: 200,
          itemHeight: 18,
          itemTextColor: '#999',
          itemDirection: 'left-to-right',
          itemOpacity: 1,
          symbolSize: 18,
          symbolShape: 'circle',
          effects: [
            {
              on: 'hover',
              style: {
                itemTextColor: '#000'
              }
            }
          ]
        }
      ]}
    />
  )
}

export default DonutChart;